import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  addProviderItem,
  AddProviderItemReq,
} from '@/app/apis/Providers/requests'
import { useToast } from '@/shad/ui/toast/use-toast'
import { parseRequestError } from '@/common/utilities'
import { ProviderQueryKeys } from '@/queries/providers/queries'

interface UseAddProductOptions {
  providerId: number
  programId: number
  onSuccess?: () => void
  onError?: (error: Error) => void
}

export const useAddProduct = ({
  providerId,
  programId,
  onSuccess,
  onError,
}: UseAddProductOptions) => {
  const queryClient = useQueryClient()
  const { toast } = useToast()

  return useMutation({
    mutationFn: async (payload: AddProviderItemReq) => {
      return await addProviderItem(payload)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ProviderQueryKeys.providerItemCategories(
          providerId,
          programId
        ),
      })
      onSuccess?.()
    },
    onError: (error: Error) => {
      const errorMessage = parseRequestError(error).message
      toast({
        title: 'Add Failed',
        description: errorMessage,
        variant: 'destructive',
      })
      onError?.(error)
    },
  })
}
